<template>
    <div v-if="!multiline" class="price-block d-flex align-items-center">
        <div v-if="discountValue" class="old-price">
            <span class="price-integer">{{ intOldPrice }}</span>
            <span class="price-decimal">{{ decOldPrice }}</span>
        </div>
        <div class="sale">
            <span class="price-integer">-{{ intDiscountPrice }}</span>
            <span class="price-decimal">{{ decDiscountPrice }}</span>
            <span v-if="discount.type === 0" class="price-currency">%</span>
        </div>
        <div class="price">
            <span class="price-integer">{{ intTotalPrice }}</span>
            <span class="price-decimal">{{ decTotalPrice }}</span>
            <span class="price-currency"> грн</span>         
        </div>
    </div>
    <div v-else class="price-block">
        <div v-if="discountValue" class="d-flex align-items-center">
            <div class="old-price">
                <span class="price-integer">{{ intOldPrice }}</span>
                <span class="price-decimal">{{ decOldPrice }}</span>
            </div>
            <div class="sale">
                <span class="price-integer">-{{ intDiscountPrice }}</span>
                <span class="price-decimal">{{ decDiscountPrice }}</span>
                <span v-if="discount.type === 0" class="price-currency">%</span>
            </div>
        </div>
        <div class="price">
            <span class="price-integer">{{ intTotalPrice }}</span>
            <span class="price-decimal">{{ decTotalPrice }}</span>
            <span class="price-currency"> грн</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        discount: {
            type: Object,
            default() {
                return {}
            }
        },
        price: {
            type: Number,
            default: 0.00
        },
        oldPrice: {
            type: Number,
            default: 0.00
        },
        multiline: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        intTotalPrice() {
            return Math.floor(this.price)
        },
        decTotalPrice() {
            return `.${this.price.toFixed(2).slice(-2)}`
        },
        discountValue() {
            return this.discount
        },
        intOldPrice() {
            return Math.floor(this.oldPrice)
        },
        decOldPrice() {
            return '.'+this.oldPrice.toFixed(2).slice(-2)
        },
        intDiscountPrice() {
            return Math.floor(this.discount.value)
        },
        decDiscountPrice() {
            const decimals = this.discount?.value.toFixed(2).slice(-2)
            if (1 * decimals > 0) {
                return `.${decimals}`
            }
            return
        },
    },
}
</script>
